import * as React from 'react'
import { connect } from 'react-redux'
import {Container, Card, CardImg, Row, CardHeader, Label} from "reactstrap";
import {ApplicationState} from "src/store";
import {ProductFamilyIcons, ProductFamilyIconsInner} from "src/services/api";
import {selectSubCategoryPageAction} from "App/routes";
import {WithTranslation, withTranslation} from "react-i18next";

interface StateToProps {
    catId: number | null
    subcategories: ProductFamilyIcons | null
}

interface DispatchToProps {
    onChoose: (catId: number, subId:number) => void
}

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    catId: state.data.subcategories?state.data.subcategories.catId:null,
    subcategories: state.data.subcategories?state.data.subcategories.subcategory:null,
});

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onChoose: (catId: number, subId:number) => dispatch(selectSubCategoryPageAction(catId, subId))
});

class _Container extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {
    render() {
        const {i18n, catId, subcategories, onChoose, t} = this.props;
        return  <Container className="py-5">
            <Row>
                {
                    catId?
                        subcategories&&subcategories.length?
                            subcategories
                                .sort((i1:ProductFamilyIconsInner, i2:ProductFamilyIconsInner) => (i1.pos||9999)-(i2.pos||9999))
                                .map((subcategory: ProductFamilyIconsInner, index: number) => (
                                <div className="col-md-3 col-sm-3 col-xs-3 p-s" key={subcategory.id}>
                                    <Card className="productListWrap" onClick={() => onChoose(catId, subcategory.id)}>
                                        <CardHeader className={"text-truncate"}>{subcategory.nameml[i18n.languages[0]]}</CardHeader>
                                        <CardImg src={subcategory.iconurl} alt={subcategory.nameml[i18n.languages[0]]} className="p-2"/>
                                    </Card>
                                </div>)
                            ):
                            <Label>{ t('products.configuration.nocategories') }</Label>
                        :null
                }
            </Row>
        </Container>
    }
}

export const CategoryPage = connect (mapStateToProps, mapDispatchToProps)(withTranslation('common')(_Container));


// WEBPACK FOOTER //
// ./src/containers/CategoryPage.tsx